var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check_7699488",
    d: "M8,0c6.588,0,8,1.412,8,8-1.333,6.667-8,8-8,8S1.333,14.667,0,8C0,1.412,1.412,0,8,0Zm3.138,5.529a.667.667,0,0,1,0,.943L7.8,9.8a.667.667,0,0,1-.943,0L5.529,8.471a.667.667,0,0,1,.943-.943l.862.862L10.2,5.529A.667.667,0,0,1,11.138,5.529Z",
    fill: "#df9426",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusCheckIcon);
export default __webpack_public_path__ + "static/media/status_check_icon.bedb63c2860b57eebb7c1d30304129a1.svg";
export { ForwardRef as ReactComponent };